import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ErrorAlert from './Alerts';

function CurrentUserErrorNotice() {
  const currentUserError = useSelector(state => state.user.currentUserError);
  const {t} = useTranslation();

  return <ErrorAlert
    severity='error'
    open={Boolean(currentUserError)}
    message={t('account.text.unavailable')}
  />;
}

export default CurrentUserErrorNotice;